<template>
    <div>
      <apexchart
        type="pie"
        :height="height"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </template>
  
  <script>
  export default {
    name: 'PieChart',
    props: {
      series: {
        type: Array,
        required: true
      },
      height: {
        type: Number,
        required: true
      },
      labels: {
        type: Array,
        required: true
      },
      useColors: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ifDefaultTheme(){
        return  process.env.VUE_APP_THEME == 0
      },  
      colorList() {
        return this.ifDefaultTheme ? [ '#f46a6a', '#008FFB', '#2ecc71'] : [ '#f46a6a', '#4f81bd', '#2ecc71'];
      },
      chartOptions() {
        return {
          chart: {
            type: 'pie',
            height: this.height
          },
          labels: this.labels,
          colors: this.useColors ?  [ 
                      '#008FFB',//lundi
                      '#00E396',//mardi
                      '#FEB019',//mercredi
                      '#FF4560',//jeudi
                      '#775DD0',//vendredi
                      '#F86624',//samedi
                      '#1B998B',//dimanche
                      '#546E7A',//non défini
                      '#3F51B5',
                      '#2E294E', 
                      '#9C27B0'
                  ] : this.colorList,
          legend: {
            position: 'bottom'
          },
          tooltip: {
            y: {
              formatter: function (value) {
                return `${value}%`;
              }
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 300
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        };
      }
    }
  };
  </script>
  